import { render, staticRenderFns } from "./kick.vue?vue&type=template&id=4a9bdf6c&scoped=true"
import script from "./kick.vue?vue&type=script&lang=js"
export * from "./kick.vue?vue&type=script&lang=js"
import style0 from "./kick.vue?vue&type=style&index=0&id=4a9bdf6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9bdf6c",
  null
  
)

export default component.exports